import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M480-186q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800t-170.5 69.5T240-552q0 71 59 162.5T480-186m0 79q-14 0-28-5t-25-15q-65-60-115-117t-83.5-110.5-51-103T160-552q0-150 96.5-239T480-880t223.5 89T800-552q0 45-17.5 94.5t-51 103T648-244 533-127q-11 10-25 15t-28 5m0-373q33 0 56.5-23.5T560-560t-23.5-56.5T480-640t-56.5 23.5T400-560t23.5 56.5T480-480" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }